import {
  CircularProgress,
  IconButton,
  Stack,
  SxProps,
  Tooltip,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import http from "../../utils/http";
import { errorToastMessage } from "../../utils/toast";

const root: SxProps = {
  width: "fit-content",
  p: 1.5,

  border: "1px solid",
  borderColor: "divider",
  borderRadius: 3,

  height: "68px",
};

const name: SxProps = {
  maxWidth: "140px",
  fontSize: "12px",
  fontWeight: 600,
};

const CompareFileWrapper = ({ res, responseId, index, type }: any) => {
  const ref = useRef<HTMLElement>(null);
  const { id: studyId, participantId } = useParams();

  const [isDownloading, setIsDownloading] = useState(false);
  const [isOverflown, setIsOverflown] = useState(false);

  useEffect(() => {
    const element = ref.current!;
    setIsOverflown(element.scrollWidth > element.clientWidth);
  }, []);

  const handleFileDownload = useCallback(async () => {
    setIsDownloading(true);

    const params: any = {
      participantId,
    };

    try {
      let url;
      if (type === "study") {
        url = `/study/${studyId}/admin-screening-responses/get_read_signed_url/${responseId}`;
      } else {
        url = `/registry/admin-screening-responses/get_read_signed_url/${responseId}`;
      }
      const { data } = await http.get<any>(url, { params });
      window.open(data.data?.files?.[index].url, "_blank");
    } catch (err) {
      errorToastMessage(err as Error);
    }

    setIsDownloading(false);
  }, [studyId, participantId, responseId, index, type]);

  return (
    <Stack direction={"row"} alignItems={"center"} gap={1} sx={root}>
      <Stack marginLeft={1} sx={{ maxWidth: "192px" }}>
        <Tooltip title={res.name} disableHoverListener={!isOverflown}>
          <Typography sx={name} noWrap ref={ref}>
            {res.name}
          </Typography>
        </Tooltip>
      </Stack>
      <IconButton size="small" onClick={handleFileDownload}>
        {isDownloading ? (
          <CircularProgress size={16} />
        ) : (
          <FileDownloadIcon fontSize="inherit" />
        )}
      </IconButton>
    </Stack>
  );
};
export default CompareFileWrapper;
